
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from './user';
import { Apollo } from 'apollo-angular';

import { map as _map } from 'lodash';

const UsersQuery = require('./gql/users.query.gql');
const UserQuery = require('./gql/user.query.gql');
const createUserMutation = require('./gql/create-user.mutation.gql');
const updateUserMutation = require('./gql/update-user.mutation.gql');
const updateCurrentUserMutation = require('./gql/update-current-user.mutation.gql');
const deleteUserMutation = require('./gql/delete-user.mutation.gql');

export interface UsersQueryResult {
  users: User[]
  usersCount: number
}

/**
 * Service to manage users
 */
@Injectable()
export class UserService {

  constructor(private apollo: Apollo) { }

  users(offset: number, limit: number): Observable<UsersQueryResult> {
    return this.apollo
      .query({
        query: UsersQuery,
        variables: {
          offset,
          limit
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        let usersData = result.data['users'];
        let usersCount = result.data['usersCount'];

        let users = _map(usersData, userData => new User(userData));

        return {
          users,
          usersCount
        };
      }));
  }

  user(id: string): Observable<User> {
    return this.apollo
      .query({
        query: UserQuery,
        variables: {
          id
        }
      }).pipe(
      map(result => new User(result.data['user'])));
  }

  create(user: User): Observable<User> {
    return this.apollo
      .mutate({
        mutation: createUserMutation,
        variables: {
          input: user.toUserInput()
        }
      }).pipe(
      map(result => new User(result.data['createUser'])));
  }

  update(id: string, user: User): Observable<User> {
    return this.apollo
      .mutate({
        mutation: updateUserMutation,
        variables: {
          id,
          input: user.toUserInput()
        }
      }).pipe(
      map(result => new User(result.data['updateUser'])));
  }

  updateCurrentUser(user: User): Observable<User> {
    return this.apollo
      .mutate({
        mutation: updateCurrentUserMutation,
        variables: {
          input: user.toCurrentUserInput()
        }
      }).pipe(
      map(result => new User(result.data['updateCurrentUser'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteUserMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteUser']));
  }
}